<template>
  <el-form ref="form"
           :model="form"
           label-width="150px">
    <div class="padding-20"
         style="color: #409eff;">一 . 组件的使用 单选tree树形组件</div>
    <br />
    <el-row>
      <el-col :span="8">
        <el-form-item label="单位使用示例:">
          <select-tree v-model="formData.minecode"
                       :options="minelist"
                       :value="formData.minecode"
                       :formData="formData"
                       :props="{
                         soleValue:'minecode',
                         value: 'id',      // ID字段名
                         label: 'deptName',  // 显示名称
                         children: 'children',
                        }"
                       style="width:100%" />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-collapse v-model="activeNames.activeNames">
          <el-collapse-item title="@code"
                            name="2">
            <div>
              <prism-editor class="my-editor height-300"
                            :key="SelectTreeCode"
                            v-model="SelectTreeCode"
                            :highlight="highlighter"
                            readonly
                            line-numbers></prism-editor>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>
    <div class="padding-20"
         style="color: #409eff;">二 . Avue框架集成的 多选tree树形组件 <el-link type="primary"
               @click="goToAvue"> 更多参数配置去Avue官网</el-link>
    </div>
    <br />
    <el-row>
      <el-col :span="24">
        <avue-form :option="option"></avue-form>
      </el-col>
      <el-col :span="24">
        <el-collapse v-model="activeNames.activeNames">
          <el-collapse-item title="@code"
                            name="3">
            <div>
              <prism-editor class="my-editor height-300"
                            :key="AvueSelectTree"
                            v-model="AvueSelectTree"
                            :highlight="highlighter"
                            readonly
                            line-numbers></prism-editor>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { getDictionaries } from "@/basic-common/util/dictionaries.js";
import { Desc, DescMethod } from '../util/demodesc'   //日志及描述说明文件
DescMethod.initialize()
export default {
  components: {
    PrismEditor: DescMethod.PrismEditor,
  },
  data() {
    return {
      activeNames: {},
      SelectTreeCode: Desc.SelectTreeCode, //SelectTree树形查询组件代码片段
      AvueSelectTree: Desc.AvueSelectTree, //AVUE SelectTree树形查询组件代码片段
      minelist: [],
      formData: {},
      option: {
        labelWidth: 150,
        submitBtn: false, //关闭提交按钮
        emptyBtn: false, //关闭清空按钮
        column: [
          {
            label: '单位多选配置效果',
            prop: 'tree',
            type: 'tree',
            multiple: true,
            span: 8,
            dicUrl: "/api/blade-system/dept/treeByUser",
            props: {
              label: "deptName",
              value: "id"
            },
          },
        ]
      }
    }
  },
  async created() {
    this.minelist = await getDictionaries('/api/blade-system/dept/treeByUser')
  },
  methods: {
    highlighter(code) {
      return DescMethod.highlight(code, DescMethod.languages.js);
    },
    htmlValue(val) {
      return DescMethod.htmlValue(val)
    },
    goToAvue() {
      window.open('https://www.avuejs.com/form/form-doc/', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
$padding-left-20: 20px;
.padding-20 {
  padding-left: $padding-left-20;
}
::v-deep .el-collapse-item__header {
  padding-left: 10px;
  background-color: rgb(247, 247, 247) !important;
}
</style>